// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__23fbW","info":"UpdateTermsInfo_info__3-v8p"};